<template>
    <div class="single-select-list-wrapper">
        <selectable-item
            v-for="option in paginatedList"
            :key="option.value"
            :label="option.label"
            :is-selected="selectedValue == option.label"
            :un-checkable="nullSelect"
            @selection-change="handleSelectionChange(option)">
        </selectable-item>
        <div class="single-select-list-tool" v-show="options.length > itemsPerPage">
            <list-pagination :mappingsPerPage="itemsPerPage"
                            :targetList="filteredList"
                            @results="handlePaginatedListResults"
                            class="pagination-spacing"
                            >
            </list-pagination>
            <list-filter :searchConfig="{targetKeys: ['label'], targetlistType: 'deep'}"
                        :targetList="options"
                        @results="handleFilterUpdate">
            </list-filter>
        </div>
    </div>
</template>

<script>
import SelectableItem from './selectable-item.vue';
import ListFilter from '../generic/list-filter.vue';
import ListPagination from '../generic/list-pagination';

export default {
    name: 'single-select-list',
    components: {
        'selectable-item': SelectableItem,
        'list-filter': ListFilter,
        'list-pagination': ListPagination,
    },
    data() {
        return {
            filteredList: this.options,
            paginatedList: [],
        }
    },
    props: {
        nullSelect: Boolean,
        options: Array,
        selectedValue: String,
        itemsPerPage: {
            type: Number,
            default: 8
        }
    },
    mounted(){
    },
    methods: {
        handleSelectionChange(option) {
            this.$emit('selection-change', option);
        },
        handleFilterUpdate(filteredList) {
            this.filteredList = filteredList;
        },
        handlePaginatedListResults(result) {
            this.paginatedList = result;
        }
    }
};
</script>

<style>
    .pagination-spacing {
        margin-bottom: 5px;
    }
    .single-select-list-wrapper {
        margin-left: 20px;
        margin-top: 5px;
    }
    .single-select-list-tool {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 10px 10px 0 0;
    }
</style>